import { combineReducers } from "redux";

import authReducer from "./authReducer";
import widgetReducer from './widgetReducer';

export const rootReducer = combineReducers({
  widgetReducer,
  authReducer,
});
